import { MEMBER_UPDATE_EVENT } from "../../lib/constants.js";
import { controlMap } from "../../lib/control.js";
import _sfc_main$1 from "./option_bar_control.vue.js";
import { convert } from "../../lib/convert.js";
import { Fragment, computed, createCommentVNode, createElementBlock, createVNode, openBlock, reactive, renderList } from "vue";
//#region src/components/option_bar/option_bar_member_group.vue
var _hoisted_1 = {
	key: 0,
	class: "d-py6",
	"data-qa": "dtc-option-bar-member-group-control"
};
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcOptionBarMemberGroup" }, {
	props: {
		component: {
			type: Object,
			required: true
		},
		members: {
			type: Array,
			required: true
		},
		values: {
			type: Object,
			required: true
		},
		controlSelector: {
			type: Function,
			required: true
		}
	},
	emits: [MEMBER_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		/**
		* The member map is a reactive data object that wraps each member and
		* provides additional data that the 'option bar control' component
		* needs without affecting the original member data object.
		*
		* @type {object}
		*/
		const memberMap = computed(() => {
			return reactive({ ...Object.fromEntries(props.members.map((member) => {
				return [getMemberKey(member), extendMember(member)];
			})) });
		});
		/**
		* Used to match members in the 'member map' to their respective values.
		*
		* @param member
		* @returns {*}
		*/
		function getMemberKey(member) {
			return member.name;
		}
		/**
		* Attempts to get the control data for a given control.
		* If the control does not exist, gets the 'base' control data.
		*
		* @param member
		* @returns {object} The control data from the 'control map'.
		*/
		function getControlData(member) {
			return controlMap[member.control] ?? controlMap.base;
		}
		function isVModel(member) {
			const tags = member.tags;
			return tags ? "model" in tags : false;
		}
		/**
		* Wraps a member with an object containing additional data about the member.
		* This is used by the 'member map' to hold data about controls.
		*
		* @param member
		* @returns {object}
		*/
		function extendMember(member) {
			const key = getMemberKey(member);
			const value = props.values[key];
			const [validControls, control] = props.controlSelector(member, value);
			return {
				...member,
				control,
				validControls
			};
		}
		/**
		* Emits an update to a member.
		*
		* @param key - The member key
		* @param e - The updated value
		*/
		function updateMember(e, key) {
			emit(MEMBER_UPDATE_EVENT, {
				member: key,
				value: e
			});
		}
		/**
		* Updates the member's control in the 'member map'.
		*
		* @param e - The updated control
		* @param key - The member key
		*/
		function updateControl(e, key) {
			const member = memberMap.value[key];
			let value;
			try {
				value = convert(member.control, e, props.values[key]);
			} catch {
				console.warn(`${member.name}: Unable to convert ${member.control} to ${e}`);
			}
			member.control = e;
			updateMember(value ?? getControlData(member).default(member), key);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(memberMap.value, (member, key) => {
				return openBlock(), createElementBlock(Fragment, { key }, [!member.hideControl ? (openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_sfc_main$1, {
					value: __props.values[key],
					label: member.label,
					"control-data": getControlData(member),
					"valid-controls": member.validControls,
					description: member.description,
					"v-model": isVModel(member),
					required: member.required,
					locked: member.lockControl,
					args: {
						defaultValue: member.defaultValue,
						validValues: member.values,
						validTypes: member.types,
						tags: member.tags
					},
					"onUpdate:value": (e) => updateMember(e, key),
					"onUpdate:control": (e) => updateControl(e, key)
				}, null, 8, [
					"value",
					"label",
					"control-data",
					"valid-controls",
					"description",
					"v-model",
					"required",
					"locked",
					"args",
					"onUpdate:value",
					"onUpdate:control"
				])])) : createCommentVNode("", true)], 64);
			}), 128))]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=option_bar_member_group.vue.js.map